// extracted by mini-css-extract-plugin
export default {"wrapper":"parallax-module--wrapper--70403","parallax":"parallax-module--parallax--36a71"};